class CollapsibleDescription extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('.collection-hero__description-toggle');
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    if (this.hasAttribute('open')) {
      this.removeAttribute('open');
    } else {
      this.setAttribute('open', '');
    }
  }
}

customElements.define('collapsible-description', CollapsibleDescription);
